var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { timeout } from 'promise-timeout';
import { BaseActionTrigger } from '../types';
import { generateHotareaActionParams, generateComponentActionParams, getComponentData } from './actionParams';
import { getComponentInstance } from '../utils/instanceMap';
var DEFAULT_MAX_TIMEOUT = 10 * 1000;
export function pipeActions(actions, component, hotArea, payload) {
    var _this = this;
    // console.log('pipeActions ===', actions);
    return function (originalEvent, _a) {
        var meta = _a.meta, global = _a.global;
        return __awaiter(_this, void 0, void 0, function () {
            var actions_1, actions_1_1, iAction, _b, actionFn, _c, maxTimeout, target, params, componentTarget, fn, e_1, e_2_1;
            var e_2, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        _e.trys.push([0, 10, 11, 12]);
                        actions_1 = __values(actions), actions_1_1 = actions_1.next();
                        _e.label = 1;
                    case 1:
                        if (!!actions_1_1.done) return [3 /*break*/, 9];
                        iAction = actions_1_1.value;
                        _b = iAction.action, actionFn = _b.action, _c = _b.maxTimeout, maxTimeout = _c === void 0 ? DEFAULT_MAX_TIMEOUT : _c, target = iAction.target;
                        params = hotArea
                            ? generateHotareaActionParams(iAction, hotArea, component, global, meta)
                            : generateComponentActionParams(iAction, component, global, meta);
                        params.payload = payload;
                        if (originalEvent) {
                            params.originalEvent = originalEvent;
                        }
                        if (typeof target === 'number') {
                            componentTarget = getComponentInstance(target);
                            if (componentTarget) {
                                params.target = getComponentData(componentTarget);
                            }
                        }
                        fn = typeof actionFn === 'object' ? actionFn.action : actionFn;
                        _e.label = 2;
                    case 2:
                        _e.trys.push([2, 7, , 8]);
                        if (!(maxTimeout === 'Infinity')) return [3 /*break*/, 4];
                        return [4 /*yield*/, fn(params)];
                    case 3:
                        _e.sent();
                        return [3 /*break*/, 6];
                    case 4: 
                    // TODO 这里原来用fn(params)返回的promise instanceof Promise 来判断是否是promise对象，总是返回false，还没找到原因。
                    return [4 /*yield*/, timeout(Promise.resolve(fn(params)), maxTimeout)];
                    case 5:
                        // TODO 这里原来用fn(params)返回的promise instanceof Promise 来判断是否是promise对象，总是返回false，还没找到原因。
                        _e.sent();
                        _e.label = 6;
                    case 6: return [3 /*break*/, 8];
                    case 7:
                        e_1 = _e.sent();
                        console.error('Action throw error: ', e_1);
                        return [3 /*break*/, 8];
                    case 8:
                        actions_1_1 = actions_1.next();
                        return [3 /*break*/, 1];
                    case 9: return [3 /*break*/, 12];
                    case 10:
                        e_2_1 = _e.sent();
                        e_2 = { error: e_2_1 };
                        return [3 /*break*/, 12];
                    case 11:
                        try {
                            if (actions_1_1 && !actions_1_1.done && (_d = actions_1.return)) _d.call(actions_1);
                        }
                        finally { if (e_2) throw e_2.error; }
                        return [7 /*endfinally*/];
                    case 12: return [2 /*return*/];
                }
            });
        });
    };
}
export function generateHandler(actions, trigger, component, hotArea) {
    if (!actions || !actions.length) {
        return undefined;
    }
    var iActions = actions.filter(function (a) { return a.trigger === trigger; });
    if (!iActions.length) {
        return undefined;
    }
    return pipeActions(iActions, component, hotArea);
}
export function generateHandlers(actions, component, hotArea) {
    var handlers = {};
    var onInit = generateHandler(actions, BaseActionTrigger.INIT, component, hotArea);
    if (onInit) {
        handlers.onInit = onInit;
    }
    var onClick = generateHandler(actions, BaseActionTrigger.CLICK, component, hotArea);
    if (onClick) {
        handlers.onClick = onClick;
    }
    var onMouseEnter = generateHandler(actions, BaseActionTrigger.MOUSE_ENTER, component, hotArea);
    if (onMouseEnter) {
        handlers.onMouseEnter = onMouseEnter;
    }
    var onMouseLeave = generateHandler(actions, BaseActionTrigger.MOUSE_LEAVE, component, hotArea);
    if (onMouseLeave) {
        handlers.onMouseLeave = onMouseLeave;
    }
    var onDoubleClick = generateHandler(actions, BaseActionTrigger.DOUBLE_CLICK, component, hotArea);
    if (onDoubleClick) {
        handlers.onDoubleClick = onDoubleClick;
    }
    var onLongPress = generateHandler(actions, BaseActionTrigger.LONG_PRESS, component, hotArea);
    if (onLongPress) {
        handlers.onLongPress = onLongPress;
    }
    var onEnterView = generateHandler(actions, BaseActionTrigger.ENTER_VIEW, component, hotArea);
    if (onEnterView) {
        handlers.onEnterView = onEnterView;
    }
    var onLeaveView = generateHandler(actions, BaseActionTrigger.LEAVE_VIEW, component, hotArea);
    if (onLeaveView) {
        handlers.onLeaveView = onLeaveView;
    }
    return handlers;
}
//# sourceMappingURL=actionHandler.js.map